// extracted by mini-css-extract-plugin
export default {"v-font-size":"14px","v-numLines":"2","v-line-height":"22px","v-fade-length":"4em","overflowFade":"overflowFade_zrNEl"};